document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".blog-posts-preview__additional-articles .blog-item");
  const loadMoreBtn = document.querySelector(".load-more-btn");
  const loadAllBtn = document.querySelector(".load-all-btn");

  if (!items.length || !loadMoreBtn) return;

  let visibleCount = 0;
  const step = 3;

  function showNextBatch() {
    let shown = 0;

    for (let i = visibleCount; i < items.length; i++) {
      if (shown >= step) break;

      items[i].classList.remove("is-hidden");
      shown++;
    }

    visibleCount += shown;

    if (visibleCount >= step && visibleCount < items.length) {
      loadAllBtn?.classList.remove("hidden");
    }

    if (visibleCount >= items.length) {
      loadMoreBtn.classList.add("hidden");
      loadAllBtn?.classList.add("hidden");
    }
  }

  function showAll() {
    items.forEach((item) => item.classList.remove("is-hidden"));

    loadMoreBtn.classList.add("hidden");
    loadAllBtn?.classList.add("hidden");
  }

  loadMoreBtn.addEventListener("click", showNextBatch);
  loadAllBtn?.addEventListener("click", showAll);
});
